<template>
  <div class="data-card py-2">
    <el-collapse v-model="activeNames" class="el-collapse--no-border">
      <el-collapse-item name="1" class="no-arrow">
        <template slot="title">
          <collapse-custom-arrow :isActive="activeNames.includes('1')">
            <h3 class="mt-0">Список товаров</h3>
          </collapse-custom-arrow>
        </template>
        <el-table size="small" :data="form.orderRows" max-height="100%" border>
          <el-table-column prop="relatedOrderNum" label="Номера заказов на продажу" min-width="220" />
          <el-table-column prop="productId" label="Код товара" min-width="120"/>
          <el-table-column prop="vendorProductCode" label="Код товара производителя" min-width="210"/>
          <el-table-column prop="name" label="Наименование товара" min-width="190" />
          <el-table-column prop="productGroupMainName" label="ТГ" min-width="90" />
          <el-table-column prop="productGroupSecondName" label="НГ" min-width="90" />
          <el-table-column prop="amountIncludeDiscount" label="Стоимость" min-width="100">
            <template slot-scope="{row}">
              {{formatPrice(row.amountIncludeDiscount)}}
            </template>

          </el-table-column>
          <el-table-column prop="quantity" label="Количество товара" min-width="170" />
          <el-table-column prop="packageQuantity" label="Кол-во упаковок по строке" min-width="210">
            <template slot-scope="{row}">
              {{row.packageQuantity !== -1 ? row.packageQuantity : ''}}
            </template>

          </el-table-column>
          <el-table-column prop="description" label="Описание товара" min-width="400"/>
          <el-table-column prop="productStatus" label="Статус поставки товара" min-width="190"/>
        </el-table>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';
import { formatPrice } from '@/commons/helpers';

export default {
  props: {
    isEdited: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    activeNames: [],

    form: {
      orderRows: [],
    },
    rules: {
      number: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
        {
          required: true,
          min: 10,
          message: MESSAGES.MIN_LENGTH(10),
          trigger: 'change',
        },
        {
          required: true,
          max: 10,
          message: MESSAGES.MAX_LENGTH(10),
          trigger: 'change',
        },
      ],
      serviceId: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      // serviceDetail: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      workDate: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      // workTime: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
    },
    pickerOptions: {
      firstDayOfWeek: 1,
      // disabledDate(time) {
      //   return time.getTime() < (new Date().getTime() - 1000 * 60 * 60 * 24);
      // },
    },
  }),
  created() {
    this.fetchServices();
    this.fillForm();
  },
  computed: {
    ...mapGetters({
      item: 'orders/item',
      services: 'servicesDrop/items',
      fetchServicesProgress: 'servicesDrop/fetchProgress',
    }),
  },
  methods: {
    ...mapActions({
      fetchServices: 'servicesDrop/fetchItems',
    }),
    formatPrice,
    fillForm() {
      if (this.item) {
        this.form.orderRows = [...this.item.visitOrderRows];
      } else {
        this.form.orderRows = [];
      }
    },
    onSave() {
      let isValid = false;
      this.$refs.form.validate((valid) => {
        isValid = valid;
      });
      const form = {
        // number: this.form.number,
        // serviceId: this.form.serviceId,
        // // serviceDetail: this.form.serviceDetail,
        // workDate: this.form.workDate,
        // workTime: this.form.workTime,
      };
      return { isValid, form };
    },
    addItemOrderList() {
      const newItem = {
        orderNumber: '',
        vendorCode: '',
        name: '',
        description: '',
        count: 1,
      };
      this.form.orderRows.push(newItem);
    },
  },
  watch: {
    item() {
      this.fillForm();
    },
  },
};
</script>
